export default __webpack_public_path__ + "static/media/Mark-3-HUD-10.edd2d9da.jpg";